require('../../modules/es6.reflect.apply');
module.exports = require('../../modules/_core').Reflect.apply;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/apply.js
// module id = yfAT
// module chunks = 3